import React from "react";

const ChartOfAccounts = () => {
  return <div>Chart of account is under construction ⚒️...</div>;
};

export default ChartOfAccounts;
